import type { WavespeedModelConfig } from '../types';
import { clampTo } from '../../tools';

export const recraftConfigs: Record<string, WavespeedModelConfig> = {
    'recraft-ai/recraft-crisp-upscale': {
        // https://wavespeed.ai/zh-CN/models/recraft-ai/recraft-crisp-upscale
        apiPath: '/recraft-ai/recraft-crisp-upscale',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { image_urls } = params;
            return {
                image: image_urls[0],
            };
        },
    },
    'recraft-ai/recraft-creative-upscale': {
        // https://wavespeed.ai/zh-CN/models/recraft-ai/recraft-creative-upscale
        apiPath: '/recraft-ai/recraft-creative-upscale',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { image_urls } = params;
            return {
                image: image_urls[0],
            };
        },
    },
    'recraft-v4.1/text-to-vector': {
        // https://wavespeed.ai/zh-CN/models/recraft-ai/recraft-v4.1/text-to-vector
        apiPath: '/recraft-ai/recraft-v4.1/text-to-vector',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio } = params;
            return {
                prompt: prompt,
                image_size: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '1:1'] as const, '16:9'),
            };
        },
    },
    'recraft-v4.1-pro/text-to-vector': {
        // https://wavespeed.ai/zh-CN/models/recraft-ai/recraft-v4.1-pro/text-to-vector
        apiPath: '/recraft-ai/recraft-v4.1-pro/text-to-vector',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio } = params;
            return {
                prompt: prompt,
                image_size: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '1:1'] as const, '16:9'),
            };
        },
    },
    'recraft-v4.1/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/recraft-ai/recraft-v4.1/text-to-image
        apiPath: '/recraft-ai/recraft-v4.1/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio } = params;
            return {
                prompt: prompt,
                image_size: clampTo(aspectRatio || '1:1', ['1:1', '16:9', '9:16', '4:3', '3:4'] as const, '1:1'),
            };
        },
    },
    'recraft-v4.1-flash/text-to-image': {
        // https://wavespeed.ai/models/recraft-ai/recraft-v4.1-flash/text-to-image
        apiPath: '/recraft-ai/recraft-v4.1-flash/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio } = params;
            return {
                prompt: prompt,
                aspect_ratio: clampTo(aspectRatio || '1:1', ['1:1', '16:9', '9:16', '4:3', '3:4'] as const, '1:1'),
            };
        },
    },
    'recraft-v4.1-pro/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/recraft-ai/recraft-v4.1-pro/text-to-image
        apiPath: '/recraft-ai/recraft-v4.1-pro/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio } = params;
            return {
                prompt: prompt,
                image_size: clampTo(aspectRatio || '1:1', ['1:1', '16:9', '9:16', '4:3', '3:4'] as const, '1:1'),
            };
        },
    },
};